import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MetricGroup } from '../../dto/MetricGroup';
import {
  MetricGroupCrudBaseModalComponent,
} from '../metric-group-crud-base-modal/metric-group-crud-base-modal.component';
import { SelectedCompanyMetrics } from '../../components/company-metrics/dto/company-metrics-data';
import { firstValueFrom } from 'rxjs';
import { SharedComponentsModule } from "../../../shared/module/shared-components.module";
import {
  KpiMetricGroupDataTypeSelectorComponent,
} from "../metric-group-crud-base-modal/kpi-metric-group-data-type-selector/kpi-metric-group-data-type-selector.component";

@Component({
  selector: 'app-modal-custom-metric-group-crud',
  templateUrl: '../metric-group-crud-base-modal/metric-group-crud-base-modal.component.html',
  standalone: true,
  styleUrls: ['../metric-group-crud-base-modal/metric-group-crud-base-modal.component.scss'],
  imports: [
    SharedComponentsModule,
    KpiMetricGroupDataTypeSelectorComponent,
  ],
})
export class ModalCreateCustomMetricGroupComponent extends MetricGroupCrudBaseModalComponent implements OnChanges {
  private readonly thinkTwiceCompanyThreshold = 3;
  @Input() allGroups: MetricGroup[] = [];
  @Input() selected: SelectedCompanyMetrics;
  showEnableForAllCompanies: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    this.type = 'metrics';
    super.ngOnChanges(changes);
  }

  override async initDeleteMetricGroup(): Promise<void> {
    const wrapper = await firstValueFrom(this.metricsService.getCompaniesWithMetricData(this.metricsGroup.value.uuid));
    this.modalText.deleteGroupDescription = this.buildTextForMetricThinkTwiceModal(wrapper.companies, this.metricsGroup.value.name);
    await super.initDeleteMetricGroup();
  }

  override deleteMetricFromMetricGroupAndCloseModal(isSuccessful: boolean): void {
    if (isSuccessful) {
      super.deleteMetricFromMetricGroup(this.metricIndexForDeleteThinkTwiceModal);
    }
    this.metricIndexForDeleteThinkTwiceModal = undefined;
  }

  override async deleteMetricFromMetricGroup(index: number): Promise<void> {
    const metric = this.metricsGroup.controls.metrics.at(index).value;
    // if metric has an uuid -> it is persisted in the system and might have metric data.
    if (!metric.uuid) {
      super.deleteMetricFromMetricGroup(index);
      return;
    }

    const wrapper = await firstValueFrom(this.metricsService.getIsMetricDeletable(metric.uuid));
    const companies = wrapper.companies;
    // there is no company which has some metric data, we can safely remove this metric.
    if (!companies.length) {
      super.deleteMetricFromMetricGroup(index);
      return;
    }

    // there is metric data in some companies -> show think twice modal.
    this.modalText.deleteMetricDescription = this.buildTextForMetricThinkTwiceModal(companies, metric.name);
    this.metricIndexForDeleteThinkTwiceModal = index;
  }

  private buildTextForMetricThinkTwiceModal(companies: string[], name: string): string[] {
    return [`${name} will be deleted.`];
  }
}
